module.exports = __webpack_public_path__ + "img/bvs_logo_fr.1eb3a848.svg";